/**
 * Created by christiancueni on 12/07/16.
 * Copyright (c) 2016 ITerativ GmbH. All rights reserved.
 */
import { Injectable } from '@angular/core';

import { CustomAction } from './CustomAction';
import { type } from '../shared/util';

export const HomeActionTypes = {
  HOME_GET_TOKEN: type("[Home] Get Token"),
  HOME_TOKEN_SUCCESS: type("[Home] Token Success"),
  HOME_TOKEN_FAILURE: type("[Home] Token Failure"),
  HOME_GET_USERDATA: type("[Home] Get Userdata"),
  HOME_USERDATA_SUCCESS: type("[Home] Userdata Success"),
  HOME_USERDATA_FAILURE: type("[Home] Userdata Failure")
};

export class GetUserData implements CustomAction {
  type = HomeActionTypes.HOME_GET_USERDATA;

  constructor() { }
}

export class UserDataSuccess implements CustomAction {
  type = HomeActionTypes.HOME_USERDATA_SUCCESS;
  //data: data
  constructor(public payload: Object) { }
}

export class UserDataFail implements CustomAction {
  type = HomeActionTypes.HOME_USERDATA_FAILURE;
  //reason: reason
  constructor(public payload:Object) { }
}

export type KlassenbuchActions =
    GetUserData
    | UserDataSuccess
    | UserDataFail
